module.exports = __webpack_public_path__ + "img/marge-vente.f76eb050.png";